import React from "react";
import { Link } from "react-router-dom";

export default function Cookiepolicy() {
  return (
    <>
      <div className="container py-5">
        <h1 className="text-center heading mb-4">Cookies Policy</h1>

        <h2 className="mt-4 privacy-heading">Introduction</h2>
        <p className="privacy-text">
          Mentation Technologies uses cookies and similar
          technologies on our website{" "}
          <a
            href="https://mentationtech.in/"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.mentationtech.in
          </a>{" "}
          to improve your browsing experience, analyze site traffic, and provide
          personalized services.
        </p>

        <h2 className="mt-4 privacy-heading">What Are Cookies?</h2>
        <p className="privacy-text">
          Cookies are small text files stored on your device by your web
          browser. They help websites remember information about your visit,
          such as preferences, login information, and activity on the site.
        </p>

        <h2 className="mt-4 privacy-heading">Types of Cookies We Use</h2>
        <ul>
          <li className="privacy-text mt-1">
            <strong>Essential Cookies:</strong> Required for basic website
            functionality and security.
          </li>
          <li className="privacy-text mt-1">
            <strong>Performance Cookies:</strong> Collect anonymous information
            about site usage to help improve performance.
          </li>
          <li className="privacy-text mt-1">
            <strong>Functionality Cookies:</strong> Remember your preferences,
            such as language or display settings.
          </li>
          <li className="privacy-text mt-1">
            <strong>Analytics Cookies:</strong> Used to understand how visitors
            interact with our website and improve user experience.
          </li>
        </ul>

        <h2 className="mt-4 privacy-heading">How We Use Cookies</h2>
        <p className="privacy-text">We use cookies to:</p>
        <ul>
          <li className="privacy-text mt-1">
            Enable login and session management
          </li>
          <li className="privacy-text mt-1">
            Remember your preferences and settings
          </li>
          <li className="privacy-text mt-1">
            Analyze website traffic and performance
          </li>
          <li className="privacy-text mt-1">
            Prevent fraudulent activity and improve security
          </li>
          <li className="privacy-text mt-1">
            Enhance your overall browsing experience
          </li>
        </ul>

        <h2 className="mt-4 privacy-heading">Third-Party Cookies</h2>
        <p className="privacy-text">
          We may allow third-party service providers, such as analytics tools,
          to place cookies on our website. These cookies help us understand how
          our site is used and how to improve it. Mentation Technologies does
          not have access to the personal data collected by third-party cookies.
        </p>

        <h2 className="mt-4 privacy-heading">Managing Cookies</h2>
        <p className="privacy-text">
          You can control or disable cookies through your browser settings. Most
          browsers allow you to refuse or delete cookies. However, please note
          that some features of the website may not function properly if cookies
          are disabled.
        </p>

        <h2 className="mt-4 privacy-heading">Consent</h2>
        <p className="privacy-text">
          By using our website, you consent to the use of cookies as described
          in this policy. If you do not agree, please adjust your browser
          settings or refrain from using certain features of the website.
        </p>

        <h2 className="mt-4 privacy-heading">Changes to This Policy</h2>
        <p className="privacy-text">
          We may update our Cookies Policy from time to time. Any changes will
          be posted on this page, and the updated date will be reflected at the
          top of the policy.
        </p>

        <h2 className="mt-4 privacy-heading">Contact Us</h2>
        <p className="privacy-text">
          For any questions regarding our Cookies Policy, please contact us at
          <Link to="mailto:support@mentationtech.in"> support@mentationtech.in</Link>.
        </p>
      </div>
    </>
  );
}
